export default {"src":"/_next/static/media/sport-medal.e82f8c54.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};